import { buildQueryParams, feberApiDelete, feberApiGet, feberApiPost, feberApiPut } from "../../../../../services/commonServices";
import { IDBRole, ISetRolesPayload, IUserRoleAssignment } from "./types";

export const getAllUserRoleAssignments = async (): Promise<IUserRoleAssignment[]> => {
    try {
        return await feberApiGet<IUserRoleAssignment[]>("Role/GetAllUserRoleAssignments");
    } catch (error: any) {
        console.error("Failed to get all user role assignments:", error);
        throw error;
    }
}

export const getAllRoles = async (): Promise<IDBRole[]> => {
    try {
        return await feberApiGet<IDBRole[]>("Role/GetAllRoles");
    } catch (error: any) {
        console.error("Failed to get all roles:", error);
        throw error;
    }
}

export const unsetRoles = async (payload: ISetRolesPayload): Promise<boolean> => {
    try {
        // Backend expects query parameters: peopleId (string) and roleIds (List<int>)
        return await feberApiDelete<boolean>("Role/UnsetRole", payload);
    } catch (error: any) {
        console.error("Failed to unset roles:", error);
        throw error;
    }
}

export const setRoles = async (payload: ISetRolesPayload): Promise<boolean> => {
    try {
        return await feberApiPost<boolean>("Role/SetRole", payload);
    } catch (error: any) {
        console.error("Failed to set roles:", error);
        throw error;
    }
}

export const updateUserRoles = async (payload: ISetRolesPayload): Promise<boolean> => {
    try {
        return await feberApiPut<boolean>("Role/UpdateUserRoles", payload);
    } catch (error: any) {
        console.error("Failed to set roles:", error);
        throw error;
    }
}

export const deleteUserRoles = async (peopleIds: string[]): Promise<boolean> =>{
    try {
        // Backend expects array of peopleIds as query parameters
        return await feberApiDelete<boolean>("Role/RemoveUserAndRoles", { peopleIds });
    } catch (error: any) {
        console.error("Failed to delete user roles:", error);
        throw error;
    }
}

export const addNewRole = async (roleName: string, roleDescription: string): Promise<IDBRole> => {
    try {
        const payload = {
            name: roleName,
            description: roleDescription
        };
        return await feberApiPost<IDBRole>("Role/NewRole", payload);
    } catch (error: any) {
        console.error("Failed to add new role:", error);
        throw error;
    }
}

export const updateRole = async (roleId: number, roleName: string, roleDescription: string): Promise<IDBRole> => {
    try {
        const payload = {
            id: roleId,
            name: roleName,
            description: roleDescription
        };
        return await feberApiPut<IDBRole>("Role/UpdateRole", payload);
    } catch (error: any) {
        console.error("Failed to update role:", error);
        throw error;
    }
}

export const deleteRoles = async (roleIds: number[]): Promise<IDBRole[]> => {
    try {
        return await feberApiDelete<IDBRole[]>("Role/DeleteRoles", { roleIds });
    } catch (error: any) {
        console.error("Failed to delete role:", error);
        throw error;
    }
}


